import React from 'react';
import { makeStyles } from '@material-ui/core';
const styles = makeStyles({
    hourCell: {
        height: '108px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        fontSize: '14px',
        color: '#8b8f92',
        position: 'relative',
        '&:first-child': {
            '& > div': {
                position: 'absolute',
                top: '-10px'
            }
        },
        '& > div': {
            position: 'absolute',
            top: '-14px'
        }
    },
    hoursContainer: {
        paddingTop: '10px'
    }
});
const HOURS = Array(24);
for (let i = 0; i < 24; i++) {
    HOURS.push(i);
}
export default function HoursColumn() {
    const classes = styles();
    return (
        <div className={classes.hoursContainer}>
            {HOURS.map((hour, index) => (
                <div id={`hour-${hour}`} className={classes.hourCell} key={index}>
                    {hour < 12 ? (
                        <div>{hour === 0 ? 12 : hour} AM</div>
                    ) : hour < 24 ? (
                        <div>{hour === 12 ? 12 : hour - 12} PM</div>
                    ) : null}
                </div>
            ))}
        </div>
    );
}
